import React from 'react';
import ProjectHeader from '../ProjectHeader';
import './ProjectPage.css'; // Custom styles for this project

const RGC = ({ project }) => {  

  return (
    <div className="rgc-page">
      <ProjectHeader 
        title={project.title}
        date={project.date}
        featured={project.featured}
      />
      
      <div className="project-content">
        <p>
        Apparently eyeballs are a hot commodity in the research community. Most eyeballs go bad within a couple of days, and researchers
        scramble to get meaningful results from these ticking time bombs. That leaves a very obvious issue, how can anyone do any experiments at all when
        there is so much time pressure? This motivated us to simulate these eyeballs (actually retinal ganglion cells which are inside eyeballs).
        </p>
        <p>
            We did this using the Jaxley simulator. An implementation of the Hodgkin-Huxley Biophysical Model written in 1952!! They were absolute
            to define many equations that can simulate how a neuron spikes. This being implemented in Jax allows us to quickly fit a Retinal Ganglion Cell to 
            data that was collected previously. The data was formatted as these electrical images, these videos where we can see the neuron itself spiking.
        </p>
        <figure className="my-8">
        <div className="w-full max-w-3xl mx-auto">
          <video 
            className="w-full rounded-lg shadow-lg"
            controls
            preload="metadata"

          >
            <source src="/files/rgc/true_cell.m4v" type="video/x-m4v" />
            Your browser does not support the video tag.
          </video>
        </div>
        <figcaption className="figure-text">
          <strong>Figure 1:</strong> One of our cells spiking!
        </figcaption>
      </figure>

        <p>
          A couple things were necessary to make this functional. First, to create these electrical image videos, we had to sort amongst all the 
          spikes that were happening. There, in fact, is more than one cell spiking in this hexagonal arrangement, but the dataset was able to pull many
          of the spikes apart using Kilosort (Pachitariu, 2024). Because of this spike sorting process, we actually only have the spike itself. This poses some issues though,
          there is data before the spikes unfortunately. A build up of sorts. Our simulator produced data that lead up to the spike as well.
          Our solution for this was to use a time-matching/convolutional-like approach. Where we compared the mean squared error of our simulated spike in a window the size of 
          the simulated spike. This proved to work pretty well! Here is our trained eletrical image when we only adjust the parameters for location of the cell.

        </p>
        <div style={{ display: 'flex', gap: '24px' }}>
        {/* Video 1 */}
        <div style={{ flex: 1 }}>
          <video style={{ width: '100%' }} controls>
            <source src="/files/rgc/true_cell.m4v" type="video/x-m4v" />
          </video>
          <p style={{ textAlign: 'center' }}></p>
        </div>
        
        {/* Video 2 */}
        <div style={{ flex: 1 }}>
          <video style={{ width: '100%' }} controls>
            <source src="/files/rgc/sim_cell.m4v" type="video/x-m4v" />
          </video>
          <p style={{ textAlign: 'center' }}></p>
        </div>
      </div>
      <p>
        If one would like to see precise equations and any more specificities, refer to the paper below! There's still much more to work on, and a new project focused on a new loss function and more robust testing will be done soon!
      </p>
        
      <section className="links-section" >
        <h3>Project Links</h3>
        <div className="project-links" >
            <a href="https://github.com/lanpouthakoun/fast-fitting-jaxley" 
            target="_blank" 
            rel="noopener noreferrer"
            >
            View Source Code
            </a>
            <a href="/files/rgc/Fast_Fitting.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            >
            View Paper
            </a>
        </div>
        </section>
        
        
      </div>
    </div>
  );
};

export default RGC;